import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/tab';

const loadHoldState = () => {
  if (!$(this).hasClass('modal-tab')) {
    if (location.hash.substr(0, 2) === '#!') {
      $('a[href="#' + location.hash.substr(2) + '"]').tab('show');
    }
  }

  $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
    if (!$(this).hasClass('modal-tab')) {
      const hash = $(e.target).attr('href');
      if (hash.substr(0, 1) === '#') {
        e.preventDefault();
        history.pushState({}, '', '#!' + $(this).attr('href').slice(1));
      }
    }
  });
};

export default loadHoldState;
